'use strict';

angular.module('chatEngine.accountSettings', [
    'chatEngine.services'
])

.controller('AccountSettingsCtrl', ['$scope', '$http', '$timeout', 'sessionDataService',
'imageUploadService', 'Dialog', '$filter', 'USERNAME_REGEX', 'MAX_ADMINS_PER_BOT',
'DISPLAY_NAME_REGEX',
function($scope, $http, $timeout, sessionDataService, imageUploadService, Dialog, $filter, USERNAME_REGEX,
         MAX_ADMINS_PER_BOT, DISPLAY_NAME_REGEX) {
    var SNOWMAN = 'assets/img/snowman-big@2x.png';

    $scope.editingDisplayName = false;
    $scope.savingDisplayName = false;
    $scope.newAdmin = null;
    $scope.savingAdmins = false;
    $scope.admins = [];

    function init() {
        if (!sessionDataService.isInitialized()) {
            return;
        }

        $scope.currentBot = sessionDataService.getCurrentBotData();
        $scope.displayName = $scope.currentBot.display_name;
        $scope.newDisplayName = $scope.currentBot.display_name;
        $scope.username = sessionDataService.getKikUsername().toLowerCase(); // current admin username
        if (!$scope.currentBot.display_pic) {
            $scope.displayPic = SNOWMAN;
        } else {
            $scope.displayPic = $filter('profilePicUrlHttpToHttps')($scope.currentBot.display_pic);
        }
        $scope.admins = $scope.currentBot.admins.map(function(admin) {
            return admin.toLowerCase(); // Just in case, let's make everything lowercase
        });
    }

    $scope.inputEdited = function() {
        $scope.invalidDisplayName = false;
        $scope.editingDisplayName = true;
    };

    $scope.validForm = function() {
        if (!$scope.displayName.length) {
            return false;
        }
        if ($scope.showImageLoader) {
            return false;
        }
        return true;
    };

    $scope.isValidNewDisplayName = function() {
        return Boolean($scope.newDisplayName && DISPLAY_NAME_REGEX.test($scope.newDisplayName));
    };

    $scope.cancelEditDisplayName = function() {
        $scope.newDisplayName = $scope.displayName;
        $scope.editingDisplayName = false;
    };

    $scope.saveNewDisplayName = function() {
        $scope.savingDisplayName = true;

        var data = {display_name: $scope.newDisplayName};
        $http.put('/api/v1/bot/' + $scope.currentBot.id + '/display_name', data).then(function() {
            $scope.savingDisplayName = false;
            $scope.displayName = $scope.newDisplayName;
            $scope.editingDisplayName = false;
        }, function(resp) {
            if(resp.data.message) {
                Dialog.alert('Error', 'Error while updating display name: ' + resp.data.message + '.');
            } else {
                Dialog.alert('Error', 'Error while updating display name.');
            }
            $scope.savingDisplayName = false;
        });
    };

    $scope.browse = function() {
        $timeout(function() {
            angular.element('#display-pic-input').click();
        });
    };

    $scope.onFileInputChange = function(el) {
        // Called when choosing a profile picture from the file picker
        var chosenFile = el.files[0];
        el.value = null;

        $scope.showImageLoader = true;
        imageUploadService.upload(chosenFile, '/api/v1/bot/' + $scope.currentBot.id + '/profile_picture')
        .then(function(data) {
            var picUrl = data.url + '?v=' + Date.now();
            $scope.displayPic = picUrl;
            $scope.showImageLoader = false;
            $scope.currentBot.display_pic = picUrl;
        }, function(error) {
            if(error.message) {
                Dialog.alert('Error', 'Error while updating profile picture: ' + error.message + '.');
            } else {
                Dialog.alert('Error', 'Error while updating profile picture.');
            }
            $scope.showImageLoader = false;
        });
    };

    $scope.adminLimitReached = function() {
        return $scope.admins.length >= MAX_ADMINS_PER_BOT;
    };

    $scope.canAddAdmin = function(admin) {
        admin = (admin || '').toLowerCase();
        return !$scope.adminLimitReached() &&
            $scope.admins.indexOf(admin) === -1 &&
            admin.match(USERNAME_REGEX);
    };

    $scope.addAdmin = function(admin) {
        admin = admin.toLowerCase();
        if($scope.canAddAdmin(admin)) {
            $scope.savingAdmins = true;
            $http.post('/api/v1/bot/' + $scope.currentBot.id + '/admin/' + admin)
                .then(function() {
                    $scope.savingAdmins = false;
                    $scope.newAdmin = null;
                    Dialog.alert(
                        'Confirmation',
                        'A confirmation has been sent to ' + admin +
                        ', they will become an admin as soon as they accept'
                    );
                }, function(data) {
                    $scope.savingAdmins = false;

                    if(data.data.message) {
                        Dialog.alert(
                            'Error',
                            'Error trying to add "' + admin +  '" to the admin list: ' + data.data.message + '.'
                        );
                    } else {
                        Dialog.alert(
                            'Error',
                            'Error trying to add "' + admin +  '" to the admin list.'
                        );
                    }
                });
        }
    };

    $scope.removeAdmin = function(admin) {
        if(admin === $scope.username) {
            return;
        }

        Dialog.confirm('Remove Admin?', 'Remove admin "' + admin + '"?').result.then(function() {
            $scope.savingAdmins = true;
            $http.delete('/api/v1/bot/' + $scope.currentBot.id + '/admin/' + admin)
                .then(function() {
                    $scope.savingAdmins = false;

                    var ind = $scope.admins.indexOf(admin);
                    if(ind >= 0) {
                        $scope.admins.splice(ind, 1);
                    }
                }, function(data) {
                    $scope.savingAdmins = false;

                    if(data.data.message) {
                        Dialog.alert(
                            'Error',
                            'Error trying to remove "' + admin +  '" from the admin list: ' + data.data.message + '.'
                        );
                    } else {
                        Dialog.alert(
                            'Error',
                            'Error trying to remove "' + admin +  '" from the admin list.'
                        );
                    }
                });
        });
    };

    init();
    $scope.$on('sessionDataUpdated', init);
    $scope.$on('sessionDataFailed', init);
}]);
